import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tooltip-info-page-size',
  templateUrl: './tooltip-info-page-size.component.html',
  styleUrls: ['./tooltip-info-page-size.component.scss'],
  standalone: false
})
export class TooltipInfoPageSizeComponent implements OnInit {

  constructor() { }

  ngOnInit() { }

}
